import { useState } from "react";
import { Mail, ShieldCheck } from "lucide-react";
import { Shell, Head, Field, Btn, Alert } from "../../components/ui/AuthComponents";
import { useAuth } from "../../hooks/useAuth";

export default function HOALogin({ onBack, onSuccess }) {
  const { loginHOA } = useAuth();

  const [f, setF] = useState({ email: "", pass: "", hoa: "" });
  const [e, setE] = useState({});
  const [loading, setLoading]   = useState(false);
  const [apiError, setApiError] = useState("");

  const upd = k => v => {
    setF(p => ({ ...p, [k]: v }));
    setE(p => ({ ...p, [k]: "" }));
    setApiError("");
  };

  const validate = () => {
    const err = {};
    if (!f.email.trim())                      err.email = "Email required";
    else if (!/\S+@\S+\.\S+/.test(f.email))   err.email = "Invalid email format";
    if (!f.pass)                              err.pass  = "Password required";
    if (!f.hoa.trim())                        err.hoa   = "HOA Admin Code required";
    return err;
  };

  const submit = async () => {
    const err = validate();
    if (Object.keys(err).length) { setE(err); return; }

    setLoading(true);
    setApiError("");

    const result = await loginHOA({
      email:    f.email,
      password: f.pass,
      hoaCode:  f.hoa,
    });

    setLoading(false);

    if (result.error) {
      setApiError(result.error);
    } else {
      onSuccess("hoa");
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") submit(); };

  return (
    <Shell role="hoa" onBack={onBack}>
      <Head
        eyebrow="HOA Admin Portal"
        ec="#1565c0"
        title="Access your dashboard"
        sub="Sign in with your property credentials"
      />
      <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>

        {apiError && (
          <div className="fu">
            <Alert type="warn">{apiError}</Alert>
          </div>
        )}

        <Field
          label="Email Address"
          type="email"
          value={f.email}
          onChange={upd("email")}
          placeholder="admin@yourproperty.com"
          icon={Mail}
          error={e.email}
          autoFocus
          delay="d1"
          onKeyDown={handleKeyDown}
        />
        <Field
          label="Password"
          type="password"
          value={f.pass}
          onChange={upd("pass")}
          placeholder="••••••••"
          error={e.pass}
          delay="d2"
          onKeyDown={handleKeyDown}
        />
        <Field
          label="HOA Admin Code"
          value={f.hoa}
          onChange={upd("hoa")}
          placeholder="Property-specific code"
          icon={ShieldCheck}
          error={e.hoa}
          hint="Unique code assigned per property"
          delay="d3"
          maxLength={16}
          onKeyDown={handleKeyDown}
        />

        <div className="fu d4" style={{ marginTop: 4 }}>
          <Btn label="Sign In to Dashboard →" loading={loading} onClick={submit} />
        </div>
      </div>
    </Shell>
  );
}